import { Card, Illustration, Text, Stack } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { Trans } from "react-i18next";

import { CreateWebhookModal } from "./CreateWebhookModal/Modal";

interface Props {
  apiConfigurationID: string;
  onWebhookCreated: () => void;
}

export function Empty({ apiConfigurationID, onWebhookCreated }: Props) {
  return (
    <Card
      type="large"
      border="border-base"
      className={styles.wrapper}
      testID="empty-webhook-keys"
    >
      <Stack align="center" gap="space-4">
        <Illustration name="sparkles" />
        <Stack align="center" gap="space-3">
          <Text style="global/heading-medium" align="center" color="text-weak">
            <Trans>You have no webhooks</Trans>
          </Text>
          <Text style="global/body-secondary" align="center" color="text-weak">
            <Trans>Once you've added a webhook, it will appear here.</Trans>
          </Text>
          <CreateWebhookModal
            apiConfigurationID={apiConfigurationID}
            onSuccess={onWebhookCreated}
          />
        </Stack>
      </Stack>
    </Card>
  );
}

const styles = {
  wrapper: css({
    padding: "var(--space-6) var(--space-4)",
  }),
};
